import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'shared-folia-reklamowa',
  templateUrl: './folia-reklamowa.component.html',
  styleUrls: ['./folia-reklamowa.component.scss']
})

export class FoliaReklamowaComponent {

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  etykieta = 'Folia reklamowa';
}
